import { Component, OnDestroy, OnInit } from '@angular/core';
import { AppPermissionsService, AuthenticationService } from '@common/services';
import { IHeaderConfigOptionsAI } from '@core/models';
import { InsightsService, OpenAIService } from '@core/services';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'environments/environment';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-chat-sidebar',
    styleUrls: ['./chat-sidebar.component.scss'],
    templateUrl: './chat-sidebar.component.html',
    standalone: false
})
export class ChatSidebarComponent implements OnInit, OnDestroy {
  // Public
  public searchText: string;
  public selectedSource: string = null;
  public sources: IHeaderConfigOptionsAI[] = [];
  public isEnglish: boolean = false;

  private _unsubscribeAll: Subject<any>;

  /**
   * Constructor
   *
   * @param {OpenAIService} _openAIService
   * @param {TranslateService} _translateService
   */
  constructor(private _openAIService: OpenAIService,
    private _permissionsService: AppPermissionsService,
    private _translateService: TranslateService,
    private _authenticationService: AuthenticationService,
    private _log: InsightsService
  ) {
    this._unsubscribeAll = new Subject();
  }

  /**
   * On init
   */
  ngOnInit(): void {
    // Se ejecuta cuando cambia la configuración de bix
    this._openAIService.onCurrentConfigChanged.pipe(takeUntil(this._unsubscribeAll)).subscribe(resp => {
      if (resp) {
        // Se cargan las fuentes de datos
        this.sources = resp.sources
              .filter(s => this._permissionsService.hasPermissionByUrls(s.header.permissionUrls, 'READ'))
              .map(s => s.header);
      }
    });

    // Se ejecuta cuando cambia la fuente de datos seleccionada
    this._openAIService.onCurrentSourceChanged.pipe(takeUntil(this._unsubscribeAll)).subscribe(resp => {
      if (resp) {
        // Se selecciona la fuente de datos
        this.selectedSource = resp;
      }
    });

    // Se ejecuta cuando se cambia de idioma
    this._translateService.onLangChange.pipe(takeUntil(this._unsubscribeAll)).subscribe(resp => {
      this.isEnglish = resp.lang === 'en';
    });

    // Obtiene si desde el inicio esta en inglés o no
    this.isEnglish = this._translateService.currentLang === 'en';

  }

  /**
   * On Destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscription
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }

  /**
   * Función que se ejecuta al seleccionar una fuente de datos
   * @param {string} source Indica el nombre de la fuente de datos a seleccionar
   */
  selectSource(source: string){
    this._openAIService.registerSource(source);
    this._log.traceInfo(
            environment.projects.Bix,
            `Cambió la Fuente de Datos a: ${source}`,
            source,
            this._authenticationService.currentUserValue
        );
  }

}
